import React from 'react';
import css from './css.less';
import Input from '@/src/components/Antd/Input/Input';
import NumberInput from '@/src/components/Antd/NumberInput/NumberInput';
import Select from '@/src/components/Antd/Select/Select';
import { SearchSelect } from 'src/components/Antd';
import { generateOptions } from '@/src/components/Antd/Select/tools';
import { useAfterDidMountEffect } from 'src/tools/customHooks';
import { instanceType, AllTypes } from 'src/tools/helper';
import GlobalTooltip, {
  NoWrapContainer,
} from 'src/components/GlobalTooltip/GlobalTooltip';
import { formatNumber } from 'src/tools/helper';
import { EnumMode } from 'src/components/Antd/NumberInput/NumberInput';

const TableForm = (props) => {
  const [_focus, _setFocus] = React.useState(false);
  const {
    value,
    _mustEditting,
    children,
    blur,
    label,
    novaluelabel,
    defaultValue,
    containerClassName,
    valueSuffix,
    disabled,
    // rightPosition,
    // midPosition,
  } = props;

  const onFocus = (e) => {
    e.stopPropagation();
    _setFocus(true);
  };
  const onBlur = () => {
    if (!_mustEditting) _setFocus(false);
  };
  // const position = React.useMemo(() => {
  //   if (rightPosition) return css.rightPosition;
  //   if (midPosition) return css.midPosition;
  //   return '';
  // }, []);
  //   React.useEffect(() => {
  //     document.addEventListener('click', onBlur);
  //     return () => {
  //       document.removeEventListener('click', onBlur);
  //     };
  //   }, []);
  useAfterDidMountEffect(() => {
    if (_mustEditting) {
      _setFocus(true);
    }
  }, [_mustEditting]);
  useAfterDidMountEffect(() => {
    onBlur();
  }, [blur]);

  const _editting = !disabled && (_focus || _mustEditting);
  const hasValue = React.useMemo(() => {
    const isLabelNumber = instanceType(label) === AllTypes.Number;
    const isValueNumber = instanceType(value) === AllTypes.Number;
    return Boolean(
      label || value || defaultValue || isLabelNumber || isValueNumber,
    );
  }, [value, label]);

  let _value = value;
  let _label = label;
  let valueTooltip = value;
  if (hasValue && instanceType(value) === AllTypes.Number) {
    _value = '' + _value;
  }
  if (hasValue && instanceType(label) === AllTypes.Number) {
    _label = '' + _label;
  }

  if (valueSuffix) {
    _value = _value + valueSuffix;
    valueTooltip = valueTooltip + valueSuffix;
  }

  return (
    <div className={`${css.container} ${containerClassName}`} onClick={onFocus}>
      {_editting ? (
        <div className={css.edittingContainer}>{children}</div>
      ) : (
        <NoWrapContainer>
          {hasValue ? (
            <GlobalTooltip title={label || valueTooltip || defaultValue}>
              {_label || _value || defaultValue}
            </GlobalTooltip>
          ) : (
            novaluelabel || '-'
          )}
        </NoWrapContainer>
      )}
    </div>
  );
};
const Wrapper = (WrapperComponent: any) => {
  const WrappedComponent = (props: any) => {
    const {
      error,
      value,
      label,
      rightPosition,
      midPosition,
      novaluelabel,
      containerClassName,
      defaultValue,
      onBlurCallback,
      formProps = {},
      disabled,
      ...rest
    } = props;
    const [onBlur, setOnBlur] = React.useState(null);
    const isOnBlur = async () => {
      try {
        if (onBlurCallback) {
          await onBlurCallback();
        }
        setOnBlur(JSON.stringify(new Date()));
      } catch (err) {
        setOnBlur(JSON.stringify(new Date()));
      }
    };

    const genProps = {
      novaluelabel,
      rightPosition,
      midPosition,
      blur: onBlur,
      _mustEditting: error,
      containerClassName,
      defaultValue,
      value,
      label,
      disabled,
      ...formProps,
    };

    const childProps = {
      error,
      value,
      label,
      defaultValue,
      disabled,
      ...rest,
      _onBlur: isOnBlur,
    };
    const returnComp = (
      <TableForm {...genProps}>
        <WrapperComponent {...childProps} />
      </TableForm>
    );
    return returnComp;
  };
  return WrappedComponent;
};

const _TableSerachSelect = (props) => {
  const { _onBlur, error, value, ...rest } = props;
  return (
    <SearchSelect
      autoFocus
      onBlur={_onBlur}
      error={error}
      value={value}
      {...rest}
    />
  );
};
const _TableInput = (props) => {
  const { _onBlur, error, value, ...rest } = props;
  return (
    <Input autoFocus onBlur={_onBlur} error={error} value={value} {...rest} />
  );
};
const _TableSelect = (props) => {
  const { _onBlur, error, value, ...rest } = props;
  return (
    <Select autoFocus onBlur={_onBlur} error={error} value={value} {...rest} />
  );
};
const TableInput = Wrapper(_TableInput);
const TableSearchSelect = Wrapper(_TableSerachSelect);
const TableSelect = Wrapper(_TableSelect);
const TableNumberInput = (props) => {
  //src/pages/Settings/Communication/Components/FormComponents via cloneElement
  const {
    error,
    value,
    label,
    rightPosition,
    midPosition,
    novaluelabel,
    formProps = {},
    mode,
    valueSuffix,
    disabled,
    onFieldBlur,
    ...rest
  } = props;
  const [onBlur, setOnBlur] = React.useState(null);
  const isOnBlur = () => {
    setOnBlur(JSON.stringify(new Date()));
  };
  const genProps = {
    novaluelabel,
    rightPosition,
    midPosition,
    blur: onBlur,
    _mustEditting: error,
    value: mode === EnumMode.money ? formatNumber(value) : value,
    label,
    valueSuffix,
    disabled,
    ...formProps,
  };

  return (
    <TableForm {...genProps}>
      <NumberInput
        autoFocus
        mode={mode}
        onBlur={(e) => {
          if (onFieldBlur) {
            onFieldBlur(e.target.value);
          }
          isOnBlur();
        }}
        error={error}
        value={value}
        disabled={disabled}
        {...rest}
      />
    </TableForm>
  );
};

export {
  TableSearchSelect,
  TableInput,
  TableSelect,
  TableNumberInput,
  generateOptions,
  Wrapper,
};
